import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const ModalAlert = ({ isOpen, closeModal, variable1 }) => {

    const dialogRef = useRef(null);

    const [t2, i18n] = useTranslation("global");

    useEffect(() => {

        const dialog = dialogRef.current;
    
        if (!dialog) return;
    
        if (isOpen && !dialog.open) {
    
            setTimeout(() => {
                dialog.showModal();
            }, 0);
    
        } else if (!isOpen && dialog.open) {
    
            dialog.close();
    
        }
    
    }, [isOpen]);

    // Sincroniza cierre manual (ESC)
    useEffect(() => {

        const dialog = dialogRef.current;

        if (!dialog) return;

        const handleCancel = () => {
            closeModal();
        };

        dialog.addEventListener("cancel", handleCancel);

        return () => {
            dialog.removeEventListener("cancel", handleCancel);
        };

    }, [closeModal]);

    const handleClose = () => {

        dialogRef.current?.close();
        closeModal();

    };

    return (
        <dialog ref={dialogRef} className="write-me-modal">

            <section className="write-me-modal__panel">

                {/* CERRAR */}
                <button
                    type="button"
                    className="write-me-modal__close"
                    onClick={handleClose}
                >
                    ✕
                </button>

                <div className="write-me-modal__form">

                    <div className="write-me-modal__body">

                        <div className="write-me-modal__success">

                            <img
                                className="img-success-pal"
                                src="/assets/img2026/palomita.svg"
                                alt="Success"
                            />

                            <h2 className="write-me-modal__title">
                                {variable1}
                            </h2>

                            <button
                                type="button"
                                className="btnSuscri subscribe-modal__submit typo-book-title"
                                onClick={handleClose}
                            >
                                {i18n.language === "en"
                                    ? "Close"
                                    : "Cerrar"}
                            </button>

                        </div>

                    </div>

                </div>

            </section>

        </dialog>
    );
};

export default ModalAlert;